import React from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
    useLocation
} from "react-router-dom";
import Menu from "./components/menu";
import PrivateTours from "./pages/PrivateTours";
import AddPrivateTour from "./pages/AddPrivateTour";
import EditPrivateTour from "./pages/EditPrivateTour";
import GroupTours from "./pages/GroupTours";
import AddGroupTour from "./pages/AddGroupTour";
import EditGroupTour from "./pages/EditGroupTour";
import TourPackages from "./pages/TourPackages";
import AddTourPackage from "./pages/AddTourPackage";
import Abroad from "./pages/Abroad";
import AddAbroad from "./pages/AddAbroad";
import EditAbroad from "./pages/EditAbroad";
import OtherTours from "./pages/OtherTours";
import AddOtherTour from "./pages/AddOtherTour";
import EditOtherTour from "./pages/EditOtherTour";
import Armenia from "./pages/Armenia";
import AddArmenia from "./pages/AddArmenia";
import EditArmenia from "./pages/EditArmenia";
import Hotels from "./pages/Hotels";
import AddHotel from "./pages/AddHotel";
import Apartment from "./pages/Apartment";
import AddApartment from "./pages/AddApartment";
import Restaurant from "./pages/Restaurant";
import AddRestaurant from "./pages/AddRestaurant";
import Embassy from "./pages/Embassy";
import AddEmbassy from "./pages/AddEmbassy";
import Region from "./pages/Region";
import AddNews from "./pages/AddNews";
import News from "./pages/News";
import Guide from "./pages/Guide";
import AddGuide from "./pages/AddGuide";
import EditGuide from "./pages/EditGuide";
import Seo from "./pages/Seo";
import EditTourPackage from "./pages/EditTourPackage";
import EditHotel from "./pages/EditHotel";
import EditApartment from "./pages/EditApartment";
import EditRestaurant from "./pages/EditRestaurant";
import EditEmbassy from "./pages/EditEmbassy";
import EditNews from "./pages/EditNews";
import Login from "./pages/Login";
import BookingManagement from "./pages/BookingManagement";

const isAuthenticated = () => !!localStorage.getItem('adminToken');

const PrivateRoute = ({ element }) => {
    return isAuthenticated() ? element : <Navigate to="/login" replace />
}

const Layout = ({ children }) => {
    const location = useLocation();
    const isAuth = isAuthenticated();
    const hideMenu = !isAuth || location.pathname === '/login';
    return (
        <>
            {!hideMenu && <Menu/>}
            {children}
        </>
    )
}

const App = () => {
    return (
        <div id='app'>
            <Router>
                <Layout>
                    <Routes>
                        <Route path="/login" element={<Login/>} />

                        <Route path="/private-tours" element={<PrivateRoute element={<PrivateTours/>} />} />
                        <Route path="/tour-packages" element={<PrivateRoute element={<TourPackages/>} />} />
                        <Route path="/add-private-tour" element={<PrivateRoute element={<AddPrivateTour/>} />} />
                        <Route path="/add-tour-package" element={<PrivateRoute element={<AddTourPackage/>} />} />
                        <Route path="/edit-tour-package/:id" element={<PrivateRoute element={<EditTourPackage/>} />} />
                        <Route path="/group-tours" element={<PrivateRoute element={<GroupTours/>} />} />
                        <Route path="/edit-private-tour/:id" element={<PrivateRoute element={<EditPrivateTour/>} />} />
                        <Route path="/edit-group-tour/:id" element={<PrivateRoute element={<EditGroupTour/>} />} />
                        <Route path="/add-group-tour" element={<PrivateRoute element={<AddGroupTour/>} />} />
                        <Route path="/abroad" element={<PrivateRoute element={<Abroad/>} />} />
                        <Route path="/edit-abroad/:id" element={<PrivateRoute element={<EditAbroad/>} />} />
                        <Route path="/add-abroad" element={<PrivateRoute element={<AddAbroad/>} />} />
                        <Route path="/other-tours" element={<PrivateRoute element={<OtherTours/>} />} />
                        <Route path="/add-other-tour" element={<PrivateRoute element={<AddOtherTour/>} />} />
                        <Route path="/edit-other-tour/:id" element={<PrivateRoute element={<EditOtherTour/>} />} />
                        <Route path="/armenia" element={<PrivateRoute element={<Armenia/>} />} />
                        <Route path="/add-armenia" element={<PrivateRoute element={<AddArmenia/>} />} />
                        <Route path="/edit-armenia/:id" element={<PrivateRoute element={<EditArmenia/>} />} />
                        <Route path="/add-news" element={<PrivateRoute element={<AddNews/>} />} />
                        <Route path="/edit-news/:id" element={<PrivateRoute element={<EditNews/>} />} />
                        <Route path="/hotel" element={<PrivateRoute element={<Hotels/>} />} />
                        <Route path="/edit-hotel/:id" element={<PrivateRoute element={<EditHotel/>} />} />
                        <Route path="/add-hotel" element={<PrivateRoute element={<AddHotel/>} />} />
                        <Route path="/apartment" element={<PrivateRoute element={<Apartment/>} />} />
                        <Route path="/add-apartment" element={<PrivateRoute element={<AddApartment/>} />} />
                        <Route path="/edit-apartment/:id" element={<PrivateRoute element={<EditApartment/>} />} />
                        <Route path="/restaurant" element={<PrivateRoute element={<Restaurant/>} />} />
                        <Route path="/add-restaurant" element={<PrivateRoute element={<AddRestaurant/>} />} />
                        <Route path="/edit-restaurant/:id" element={<PrivateRoute element={<EditRestaurant/>} />} />
                        <Route path="/embassy" element={<PrivateRoute element={<Embassy/>} />} />
                        <Route path="/add-embassy" element={<PrivateRoute element={<AddEmbassy/>} />} />
                        <Route path="/edit-embassy/:id" element={<PrivateRoute element={<EditEmbassy/>} />} />
                        <Route path="/region" element={<PrivateRoute element={<Region/>} />} />
                        <Route path="/news" element={<PrivateRoute element={<News/>} />} />
                        <Route path="/guide" element={<PrivateRoute element={<Guide/>} />} />
                        <Route path="/add-guide" element={<PrivateRoute element={<AddGuide/>} />} />
                        <Route path="/edit-guide/:id" element={<PrivateRoute element={<EditGuide/>} />} />
                        <Route path="/seo" element={<PrivateRoute element={<Seo/>} />} />
                        <Route path="/bookings" element={<PrivateRoute element={<BookingManagement/>} />} />

                        <Route path="*" element={<Navigate to={isAuthenticated() ? '/private-tours' : '/login'} replace />} />
                    </Routes>
                </Layout>
            </Router>
        </div>
    );
};

export default App;